module.exports = __webpack_public_path__ + "img/140-0ebd4a.png";